import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { SCOLNewCarryOutRequestComponent } from './new-carry-out-request/new-carry-out-request.component';
import { SCOLNewCarryOutRequestFormService } from './services/new-carry-out-request-form/new-carry-out-request-form.service';
import { SoilClassificationOfLandRoutingModule } from './soil-classification-of-land-routing.module';

@NgModule({
  declarations: [SCOLNewCarryOutRequestComponent],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    SoilClassificationOfLandRoutingModule,
  ],
  providers: [SCOLNewCarryOutRequestFormService],
})
export class SoilClassificationOfLandModule {}
